/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../redux-tool-kit/Hooks"
import { setToggleSidebar } from "../redux-tool-kit/reducers/LayoutSlice"
import { setLayout } from "../redux-tool-kit/reducers/ThemeCustomizerSlice"
import Footer from "./footer/Footer"
import Header from "./header/Header"
import Loader from "./loader/Loader"
import Sidebar from "./sidebar/Sidebar"
import TapTop from "./tap-top/TapTop"
import ThemeCustomizer from "./theme-customizer/ThemeCustomizer"
import { Outlet } from "react-router-dom"

const Layout = () => {
  const {layout} = useAppSelector((state)=>state.themeCustomizer)
  const {toggleSidebar,scroll} = useAppSelector((state)=>state.layout)
  const dispatch = useAppDispatch()
  const compactSidebar = () => {
    let windowWidth = window.innerWidth;
    if (layout === "compact-wrapper") {
      if (windowWidth < 1200 ) {
        dispatch(setToggleSidebar(true))
      } 
      else {
        dispatch(setToggleSidebar(false))
      }
    }else if(layout === "horizontal-wrapper") {
      if (windowWidth < 992 ) {
        dispatch(setToggleSidebar(true))
        dispatch(setLayout("compact-wrapper"))
      } 
      else {
        dispatch(setToggleSidebar(false))
        dispatch(setLayout(localStorage.getItem("layout")))
      }
    }
  }; 
  useEffect(() => {
    compactSidebar();
    window.addEventListener("resize", () => {
      compactSidebar();
    });
  }, [layout]);
  return (
    <>
      <Loader />
      <TapTop />
      <div className={`page-wrapper ${layout}`}>
        <div className={`page-header ${toggleSidebar ? "close_icon" : ""}`} style={{display: scroll ? "none" : ""}}>
          <Header />
        </div>
        <div className={`page-body-wrapper ${scroll ? "scorlled" : ""}`}>
          <Sidebar />
          <Outlet />
          <Footer />
        </div>
      </div>
      <ThemeCustomizer />
    </>
  )
}

export default Layout